// @flow
/**
 * By given template and arguments replace each `{X}` in
 * a template with appropreate value from arguments.
 * @param {string} tpl
 * @param {Array<any>} args
 * @return {string}
 * @private
 */
export default function formatString(tpl: string, ...args: Array<any>): string {
  return tpl.replace(/{(\d+)}/g, (match, number) =>
    typeof args[number] !== 'undefined' ? args[number] : match
  )
}

/**
 * Take a number and format it to have at least a lenght of 2.
 * Examples: 1 -> 01, 5 -> 05, 12 -> 12
 * @param {number} n
 * @return {string}
 * @private
 */
export function formatTwoDigits(n: string | number): string {
  return `0${n}`.slice(-2)
}
